import { SettingConst } from '../../types';

/**
 * Enable new commission model related UI change in NAM in web retailer, mainly in Sell On Faire page
 *
 * This setting also serves country audience control, thus it could be reused for non-NAM pricing update.
 * If we need to clean up, every usage needs to change to look up ip address country to decide the logic.
 */
export const ENABLE_NEW_NAM_COMMISSION_MODEL_WEB_RETAILER_230420 =
  'ENABLE_NEW_NAM_COMMISSION_MODEL_WEB_RETAILER_230420' as SettingConst<
    'ENABLE_NEW_NAM_COMMISSION_MODEL_WEB_RETAILER_230420',
    boolean,
    'RETAILER'
  >;
